export default __webpack_public_path__ + "static/media/logo-top.07f25023.svg";